// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,import_extension=none"
// @generated from file v1/common/pagination.proto (package api.v1.common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/common/pagination.proto.
 */
export const file_v1_common_pagination: GenFile = /*@__PURE__*/
  fileDesc("Chp2MS9jb21tb24vcGFnaW5hdGlvbi5wcm90bxINYXBpLnYxLmNvbW1vbiKQAQoRUGFnaW5hdGlvblJlcXVlc3QSLwoGaW50ZW50GAEgASgOMh8uYXBpLnYxLmNvbW1vbi5QYWdpbmF0aW9uSW50ZW50EhMKBmN1cnNvchgCIAEoCUgAiAEBEg0KBWxpbWl0GAMgASgFEhsKE2luY2x1ZGVfdG90YWxfY291bnQYBCABKAhCCQoHX2N1cnNvciLEAQoKUGFnaW5hdGlvbhIYCgtuZXh0X2N1cnNvchgBIAEoCUgAiAEBEhwKD3ByZXZpb3VzX2N1cnNvchgCIAEoCUgBiAEBEhgKC3RvdGFsX2NvdW50GAMgASgDSAKIAQESFQoNaGFzX25leHRfcGFnZRgEIAEoCBIZChFoYXNfcHJldmlvdXNfcGFnZRgFIAEoCEIOCgxfbmV4dF9jdXJzb3JCEgoQX3ByZXZpb3VzX2N1cnNvckIOCgxfdG90YWxfY291bnQqpgEKEFBhZ2luYXRpb25JbnRlbnQSIQodUEFHSU5BVElPTl9JTlRFTlRfVU5TUEVDSUZJRUQQABIbChdQQUdJTkFUSU9OX0lOVEVOVF9GSVJTVBABEhoKFlBBR0lOQVRJT05fSU5URU5UX05FWFQQAhIaChZQQUdJTkFUSU9OX0lOVEVOVF9QUkVWEAMSGgoWUEFHSU5BVElPTl9JTlRFTlRfTEFTVBAEQsABChFjb20uYXBpLnYxLmNvbW1vbkIPUGFnaW5hdGlvblByb3RvUAFaRGdpdGh1Yi5jb20vZHdheW5lbGF2b24vbG9jYWwtY29tbXVuaXR5LXBsYXRmb3JtL2FwaS9nZW4vZ28vdjEvY29tbW9uogIDQVZDqgINQXBpLlYxLkNvbW1vbsoCDUFwaVxWMVxDb21tb27iAhlBcGlcVjFcQ29tbW9uXEdQQk1ldGFkYXRh6gIPQXBpOjpWMTo6Q29tbW9uYgZwcm90bzM");

/**
 * Intent-based pagination request message
 *
 * @generated from message api.v1.common.PaginationRequest
 */
export type PaginationRequest = Message<"api.v1.common.PaginationRequest"> & {
  /**
   * The intent for pagination
   *
   * @generated from field: api.v1.common.PaginationIntent intent = 1;
   */
  intent: PaginationIntent;

  /**
   * Base64 encoded cursor (required for next/prev intents)
   *
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;

  /**
   * Number of items to return per page (1-100)
   *
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * Whether to include total count in response (may affect performance)
   *
   * @generated from field: bool include_total_count = 4;
   */
  includeTotalCount: boolean;
};

/**
 * Describes the message api.v1.common.PaginationRequest.
 * Use `create(PaginationRequestSchema)` to create a new message.
 */
export const PaginationRequestSchema: GenMessage<PaginationRequest> = /*@__PURE__*/
  messageDesc(file_v1_common_pagination, 0);

/**
 * Pagination response metadata
 *
 * @generated from message api.v1.common.Pagination
 */
export type Pagination = Message<"api.v1.common.Pagination"> & {
  /**
   * Cursor-based navigation
   *
   * Base64 encoded cursor to the next page, empty if no more pages
   *
   * @generated from field: optional string next_cursor = 1;
   */
  nextCursor?: string;

  /**
   * Base64 encoded cursor to the previous page, empty if on first page
   *
   * @generated from field: optional string previous_cursor = 2;
   */
  previousCursor?: string;

  /**
   * Page information (only if include_total_count was true)
   *
   * @generated from field: optional int64 total_count = 3;
   */
  totalCount?: bigint;

  /**
   * Navigation state
   *
   * Whether there are more items after this page
   *
   * @generated from field: bool has_next_page = 4;
   */
  hasNextPage: boolean;

  /**
   * Whether there are more items before this page
   *
   * @generated from field: bool has_previous_page = 5;
   */
  hasPreviousPage: boolean;
};

/**
 * Describes the message api.v1.common.Pagination.
 * Use `create(PaginationSchema)` to create a new message.
 */
export const PaginationSchema: GenMessage<Pagination> = /*@__PURE__*/
  messageDesc(file_v1_common_pagination, 1);

/**
 * Intent-based pagination intent enum
 *
 * @generated from enum api.v1.common.PaginationIntent
 */
export enum PaginationIntent {
  /**
   * @generated from enum value: PAGINATION_INTENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Request the first page
   *
   * @generated from enum value: PAGINATION_INTENT_FIRST = 1;
   */
  FIRST = 1,

  /**
   * Request the next page (requires cursor)
   *
   * @generated from enum value: PAGINATION_INTENT_NEXT = 2;
   */
  NEXT = 2,

  /**
   * Request the previous page (requires cursor)
   *
   * @generated from enum value: PAGINATION_INTENT_PREV = 3;
   */
  PREV = 3,

  /**
   * Request the last page
   *
   * @generated from enum value: PAGINATION_INTENT_LAST = 4;
   */
  LAST = 4,
}

/**
 * Describes the enum api.v1.common.PaginationIntent.
 */
export const PaginationIntentSchema: GenEnum<PaginationIntent> = /*@__PURE__*/
  enumDesc(file_v1_common_pagination, 0);

